import { Directive, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appAutoDataLabel]',
  standalone:false
})
export class AutoDataLabelDirective implements AfterViewInit, OnDestroy {
  private observer: MutationObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.applyDataLabels(); // Initial run

    // Observe the table for changes (when *ngIf updates the DOM)
    this.observer = new MutationObserver(() => this.applyDataLabels());
    this.observer.observe(this.el.nativeElement, {
      childList: true,
      subtree: true,
    });
  }

  private applyDataLabels() {
    const table = this.el.nativeElement as HTMLTableElement;
    const headers = table.querySelectorAll('thead th');

    table.querySelectorAll('tbody tr').forEach((row) => {
      // 🚨 Ignore loader rows
      if (row.classList.contains('tr-table-loader')|| row.classList.contains('tr-empty-placeholder') ) return;

      row.querySelectorAll('td').forEach((cell, index) => {
        const header = headers[index] as HTMLElement;
        if (header) {
          cell.setAttribute('data-label', header.innerText.trim());
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect(); // Clean up observer
    }
  }
}
